import { z } from "zod";
import { HttpMethodEnum, HttpParamsTypeEnum, Route } from "../../../../utils/route";
import { zodPagination, zTransaction } from "@dobrh-monorepo/core";

const requestSchema = z.object({
  sortField: z
    .union([
      z.literal("date"),
      z.literal("type"),
      z.literal("source"),
      z.literal("amount"),
      z.literal("status"),
      z.literal("recipient"),
      z.literal("subject"),
      z.literal("none"),
    ])
    .default("none"),
  isAscending: z.enum(["TRUE", "FALSE"]).transform((value) => value === "TRUE"),
  searchById: z.string().optional(),
  ...zodPagination(),
});

const responseSchema = z.object({
  transactions: z.array(zTransaction),
  count: z.number(),
});

export default {
  method: HttpMethodEnum.GET,
  paramsType: HttpParamsTypeEnum.QUERY,
  requestZodSchema: requestSchema,
  responseZodSchema: responseSchema,
} satisfies Route;
